import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";

export default function Collections() {
    const [cats, setCats] = useState([]);
    useEffect(() => {
        document.title = "Collections | Loomara";
        api.get("/categories").then(({ data }) => setCats(data));
    }, []);
    return (
        <div className="container-boutique py-16" data-testid="collections-page">
            <p className="eyebrow text-center">Collections</p>
            <h1 className="font-serif text-5xl sm:text-6xl text-ink-900 text-center mt-3">A boutique, by season.</h1>
            <p className="text-ink-500 text-center mt-3 max-w-xl mx-auto">Small-batch capsules made with care. Explore by category to find your next favourite piece.</p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
                {cats.map((c) => (
                    <Link key={c.id} to={`/category/${c.slug}`} className="card-soft block overflow-hidden group" data-testid={`collection-${c.slug}`}>
                        <div className="aspect-[4/3] overflow-hidden bg-ivory-100">
                            <img src={c.image} alt={c.name} className="w-full h-full object-cover editorial-img" loading="lazy" />
                        </div>
                        <div className="p-6">
                            <h3 className="font-serif text-2xl text-ink-900">{c.name}</h3>
                            <p className="text-xs text-sage-700 uppercase tracking-[0.22em] mt-2">Shop the collection →</p>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
